// extracted by mini-css-extract-plugin
module.exports = {"header":"linkReg_header__i63-4","importRegCard":"linkReg_importRegCard__2KM6-","dropLabel":"linkReg_dropLabel__1D41Q"};